"use client"
import type { Ref } from "react"
import cn from "classnames"

import { Asset, type AssetProps } from "~/components/primitives/Asset/Asset"
import type { MediaAsset } from "~/types/cms"

import s from "./ResponsiveAsset.module.scss"

type Props = {
  ref?: Ref<HTMLSpanElement>
  desktop?: MediaAsset
  mobile?: MediaAsset
} & Omit<AssetProps, "ref" | "asset" | "onLoad">

export const ResponsiveAsset = ({
  ref,
  className,
  desktop,
  mobile,
  ...rest
}: Props) => {
  return (
    <>
      {desktop && (
        <Asset
          ref={ref}
          className={cn(className, s.desktop, mobile && s.hasMobile)}
          asset={desktop}
          {...rest}
        />
      )}

      {mobile && (
        <Asset
          ref={ref}
          className={cn(className, s.mobile, desktop && s.hasDesktop)}
          asset={mobile}
          {...rest}
        />
      )}
    </>
  )
}
